import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_DEFAULT_OPTIONS,
  CREATE_FORM,
  DELETE_SINGLE_FORM,
  DELETE_SINGLE_QUESTION,
  DUPLICATE_PUBLISHED_FORM,
  FETCH_FORMS,
  GET_DEFAULT_OPTIONS,
  GET_FORM_SINGLE,
  SAVE_FORM,
  UPDATE_FORM,
} from 'setup/redux/Actions/Form/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_DEFAULT_OPTIONS, fetchData)
  yield takeEvery(DELETE_SINGLE_FORM, fetchData)
  yield takeEvery(SAVE_FORM, fetchData)
  yield takeEvery(CREATE_FORM, fetchData)
  yield takeEvery(FETCH_FORMS, fetchData)
  yield takeEvery(GET_FORM_SINGLE, fetchData)
  yield takeEvery(CREATE_DEFAULT_OPTIONS, fetchData)
  yield takeEvery(DELETE_SINGLE_QUESTION, fetchData)
  yield takeEvery(UPDATE_FORM, fetchData)
  yield takeEvery(DUPLICATE_PUBLISHED_FORM, fetchData)
}

export default dataSaga
